export const GET_CURRENT_UNIV_VIDEO = "GET_CURRENT_UNIV_VIDEO";
export const RESET_CURRENT_UNIV_VIDEO = "RESET_CURRENT_UNIV_VIDEO";
export const SET_CURRENT_UNIV_VIDEO_REQUEST_STATUS = "SET_CURRENT_UNIV_VIDEO_REQUEST_STATUS";
